<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 201.815"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="63.478"
            cy="122.239"
            r="9.984"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M32.328 186.269c9.207,-0.347 18.207,-0.178 27.962,1.212 2.185,0.312 4.409,0.685 6.681,1.128 -6.26,5.862 -13.038,9.631 -17.403,9.451 -4.521,-0.187 -11.316,-4.882 -17.24,-11.791z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M60.29 187.481c-0.066,-1.746 -0.541,-14.45 -1.426,-37.331 5.289,-1.538 10.447,-4.306 15.473,-8.303 1.042,1.065 2.012,2.191 2.892,3.372 3.521,4.728 5.591,10.339 4.98,16.487 -0.977,9.847 -7.736,19.878 -15.238,26.902 -2.272,-0.442 -4.496,-0.815 -6.681,-1.127z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M58.864 150.15c-5.274,1.533 -10.678,1.844 -16.214,0.933 -6.236,-1.026 -12.637,-3.602 -19.205,-7.728 0.315,-0.598 0.649,-1.171 1.002,-1.72 5.598,-8.726 15.718,-11.418 24.865,-11.418 7.677,0 17.985,4.432 25.025,11.63 -5.026,3.997 -10.184,6.765 -15.473,8.303z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M42.644 151.083c5.538,0.911 10.945,0.601 16.22,-0.933 0.885,22.881 1.36,35.585 1.426,37.331 -5.932,-0.845 -11.585,-1.239 -17.175,-1.34l-0.471 -35.058z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M42.644 151.083l0.471 35.058c-3.602,-0.065 -7.179,-0.008 -10.787,0.128 -6.65,-7.758 -12.201,-18.307 -12.201,-28.402 0.104,-5.966 1.326,-10.733 3.318,-14.512 6.566,4.125 12.966,6.701 19.199,7.728z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M20.127 157.867c0.383,-21.904 15.823,-27.65 29.185,-27.65 13.362,0 34.69,13.426 32.897,31.489 -1.792,18.064 -23.045,36.75 -32.641,36.354 -9.596,-0.396 -29.441,-21.106 -29.441,-40.193zm57.102 -12.648c-4.875,-36.28 -7.283,-60.87 -7.222,-73.769 -1.561,-33.877 -6.517,-48.419 -11.794,-53.318 -3.958,-3.674 -6.427,-3.323 -8.701,2.434 -2.228,-3.91 -3.784,-3.108 -7.041,0.768 -7.231,8.605 -10.985,26.497 -9.139,55.618 0.363,6.815 -0.194,32.404 -8.885,64.683"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="59.368"
            cy="13.734"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
